import React from 'react';
import withInfiniteScroll from 'global/components/withInfiniteScroll';
import withSearchBar from 'global/components/withSearchBar';
import { useSelector } from 'react-redux';
import { get } from 'global/lib/lodash';
import { Text } from 'global/components/text';
import { Row } from 'global/components/row';
import { ListItem } from './listitem';
import { IconButton, Icon, List } from '@material-ui/core';
import withRouter from 'react-router-dom/withRouter';
import { filterCoursesByStatus } from '../courses';

export const Courses = withRouter((props) => {
  const { courses } = props;
  const filters = useSelector((state) => get(state, 'filter.library.courses', {}));
  const [page, setPage] = props.page;

  const data = filterCoursesByStatus(courses.data, filters);

  const locationProps = get(props, 'location.state', {});

  const currentPage = get(page, 'number', 1);
  const lastPage = get(courses, 'meta.page.last-page', null);
  const updatePage = (newPage) => {
    if (lastPage <= newPage) {
      setPage((p) => ({ ...p, number: newPage }));
    }
  };

  return (
    <>
      <Row>
        <IconButton onClick={() => props.history.push('/library', locationProps)}>
          <Icon>chevron_left</Icon>
        </IconButton>
        <Text type="title_large" bold>
          Course Assignments
        </Text>
      </Row>

      <ListWithSearch loading={courses.loading} data={data} handlePageChange={updatePage} currentPage={currentPage} lastPage={lastPage} _location={{ pathname: 'library/courses' }} />
    </>
  );
});

const ListWithSearch = withSearchBar(withInfiniteScroll(ListItem, List));
